module.exports = __webpack_public_path__ + "img/Weapon_300.a8ea91c3.png";